import script from "./Pane0.vue?vue&type=script&setup=true&lang=js"
export * from "./Pane0.vue?vue&type=script&setup=true&lang=js"

import "./Pane0.vue?vue&type=style&index=0&id=a55cfcf2&scoped=true&lang=css"

import exportComponent from "/home/interact/webapp/4.frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a55cfcf2"]])

export default __exports__